<span class="label">{{ metadata.label }}</span>

<ng-container *ngFor="let value of metadata.values">
  <span #textContent *ngIf="!value.queryParams && !value.externalLink" [class.expanded]="contentExpanded()" class="text-content value">{{ value.text }}</span>

  <div *ngIf="showContentExpandButton() && hostClassFullWidth" class="hidden-content-overlay" [class.expanded]="contentExpanded()">
    <opac-button
      (click)="contentExpanded.set(!contentExpanded())"
      [ariaLabel]="contentExpandedLabel() | translate"
      [opacTooltip]="contentExpandedLabel() | translate"
    >
      <opac-icon slot="only-icon" icon="navigate_downward"></opac-icon>
    </opac-button>
  </div>

  <a
    *ngIf="value.queryParams"
    class="value"
    [queryParams]="{ query: value.queryParams }"
    [title]="metadata.label + ' ' + value.text"
    routerLink="/results"
    (click)="updateAnalyticsOrigin()"
    >{{ value.text }}</a
  >
  <a
    *ngIf="value.externalLink"
    [href]="value.externalLink.link"
    target="_blank"
    rel="noopener"
    [opacTooltip]="metadata.label + ' ' + value.text">
    <img [src]="value.externalLink.imageUrl" [alt]="value.text" loading="lazy"
  /></a>
</ng-container>
